import { Check, Minus, TriangleAlert, X } from "lucide-react";

import { firstProblem, type PipelineStep, type StepState } from "@/lib/integrations/pipeline";

import styles from "./integrations.module.css";

function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

const STATE: Record<StepState, { className: string; word: string }> = {
  good: { className: styles.pipeGood, word: "Fine." },
  warning: { className: styles.pipeWarning, word: "Needs a look." },
  danger: { className: styles.pipeDanger, word: "Problem." },
  idle: { className: styles.pipeIdle, word: "No data yet." },
};

function Glyph({ state }: { state: StepState }) {
  if (state === "good") return <Check size={13} aria-hidden />;
  if (state === "warning") return <TriangleAlert size={12} aria-hidden />;
  if (state === "danger") return <X size={13} aria-hidden />;
  return <Minus size={13} aria-hidden />;
}

/**
 * Where a run's rows went, step by step, with the number at each step and the
 * first step that has a problem marked in words.
 */
export function Pipeline({ steps, label }: { steps: PipelineStep[]; label: string }) {
  const problem = firstProblem(steps);
  return (
    <div className={styles.pipeWrap}>
      <ol className={styles.pipe} aria-label={label}>
        {steps.map((step, index) => (
          <li key={step.key} className={cx(styles.pipeStep, STATE[step.state].className)}>
            <span className={styles.pipeHead}>
              <span className={styles.pipeDot}>
                <Glyph state={step.state} />
              </span>
              {step.title}
            </span>
            <span className={styles.pipeValue}>{step.value}</span>
            <span className={styles.pipeNote}>{step.note}</span>
            <span className={styles.srOnly}>{STATE[step.state].word}</span>
            {index === problem && <span className={styles.pipeFlag}>{step.state === "danger" ? "Problem here" : "Look here"}</span>}
          </li>
        ))}
      </ol>
    </div>
  );
}
